import React from 'react';
import { ReactComponent as WrenchSVG } from './wrench.svg';

export default function WrenchIcon({width = 16, height = 16, color = '#717182'})
{
  return (
    <WrenchSVG
      width={width}
      height={height}
      style={{stroke: color}}
    />
  );
}
